export default {
  getMyShopCouponList: '/gateway/coupon/shopCoupon/getCouponList',
  getShopCouponStatus: '/gateway/coupon/shopCoupon/getCouponStatus'
}
